export const ANIMAL_TYPE_LABELS = {
  sheep: { ar: "أغنام", en: "Sheep" },
  goat: { ar: "ماعز", en: "Goat" },
  cattle: { ar: "أبقار", en: "Cattle" },
  buffalo: { ar: "جاموس", en: "Buffalo" },
};

export const DEFAULT_ENABLED_ANIMAL_TYPES = ["sheep", "goat"];

export const FATTENING_PROFILE_OPTIONS = [
  {
    id: "small_ruminants",
    labelEn: "Sheep & goat",
    labelAr: "أغنام وماعز",
    animalTypes: ["sheep", "goat"],
  },
  {
    id: "large_ruminants",
    labelEn: "Cattle & buffalo",
    labelAr: "أبقار وجاموس",
    animalTypes: ["cattle", "buffalo"],
  },
  {
    id: "all",
    labelEn: "All types",
    labelAr: "كل الأنواع",
    animalTypes: ["sheep", "goat", "cattle", "buffalo"],
  },
];

export function isFattening(registrationType) {
  return registrationType === "fattening";
}

export function requiresBirthOrAge(registrationType) {
  return registrationType === "breeding";
}

export function animalTypeOptions(enabled, locale = "ar") {
  const list = Array.isArray(enabled) && enabled.length > 0
    ? enabled
    : DEFAULT_ENABLED_ANIMAL_TYPES;
  return list.map((value) => ({
    value,
    label: ANIMAL_TYPE_LABELS[value]?.[locale] ?? value,
  }));
}

export function getAnimalTypeLabel(value, locale = "ar") {
  return ANIMAL_TYPE_LABELS[value]?.[locale] ?? value;
}

export function displayFatteningProfile(profile) {
  if (!profile) return "small_ruminants";
  return profile;
}
